import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// =====================================================================
// PARCHE DEFENSIVO ANTI "removeChild / insertBefore" (Google Translate)
// ---------------------------------------------------------------------
// Cuando el navegador del usuario tiene activada la traducción automática
// (Google Translate, Microsoft Translator, extensiones de IA), reemplaza
// nodos de texto en el DOM por sus propios <font> wrappers. Eso hace que
// React intente remover nodos que ya no son hijos del padre que él
// recuerda, y se cae con:
//     Failed to execute 'removeChild' on 'Node':
//     The node to be removed is not a child of this node.
//
// Estos shims toleran ese caso silenciosamente. NO cambian el
// comportamiento normal — solo evitan la excepción cuando el padre/hijo
// ya no coinciden por culpa del traductor.
// =====================================================================
if (typeof Node !== 'undefined' && Node.prototype) {
    const _removeChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child && child.parentNode === this) {
            return _removeChild.call(this, child);
        }
        // Nodo huérfano (Google Translate ya lo movió). Ignorar silencioso.
        return child;
    };

    const _insertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            // Si la referencia ya no es hija, simplemente apendea al final.
            return this.appendChild(newNode);
        }
        return _insertBefore.call(this, newNode, referenceNode);
    };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
